import './ChangeOrganization.scss'

const { Button, Link, MessageBox } = require('@paymongo/seeds');

interface isChangeOrganization {
  setShowForm: Function;
  tradeName: string;
}

const ChangeOrganization = ({ setShowForm, tradeName }: isChangeOrganization) => {
  const dashboardUrl: string = `${process.env.REACT_APP_DASHBOARD_URL}/developers`;

  return (
    <div className="change-organization">
      <div className="change-organization__header --mb-lg">
        <h2 className="-brand600"><strong>Change connected account</strong></h2>

        <Button type="default" className="text --bold --py-2xs" onClick={ setShowForm }>
          Back
        </Button>
      </div>

      <div className="--pb-lg">
        <MessageBox type="warning">
          Changing the connected account will disconnect your PayMongo account <br />
          <strong>({tradeName})</strong> from your Shopify store.
        </MessageBox>
      </div>
      <p>
        You will need to connect your new PayMongo account to your Shopify store.
        <br />
        <Link href={dashboardUrl} target="_blank"> Click here </Link> to get your Live API keys
        &nbsp;<span className="-shade800">(You must be logged in the PayMongo Dashboard)</span>.
      </p>
    </div>
  );
}

export default ChangeOrganization;
